import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {
        const form = this.element;
        const optionalSuffix = form.dataset.formOptionalSuffix;
        if (optionalSuffix !== undefined && optionalSuffix !== '') {
            form.style.setProperty('--form-optional-suffix', JSON.stringify(optionalSuffix));
        }
        form.querySelectorAll("input, textarea, select").forEach(field => {
            field.addEventListener("invalid", event => {
                event.preventDefault();

                let errorContainer = field.parentNode.querySelector(".form-field-error");

                if (!errorContainer) {
                    if (field.type === "checkbox" || field.type === "file") {
                        const parentWrapper = field.parentNode?.parentNode;
                        if (!parentWrapper) return;

                        errorContainer = parentWrapper.querySelector(".form-field-error");
                        if (!errorContainer) {
                            errorContainer = document.createElement("span");
                            errorContainer.className = "form-field-error";
                            parentWrapper.appendChild(errorContainer);
                        }
                    } else {
                        return;
                    }
                }

                errorContainer.innerHTML = "";

                const error = document.createElement("span");
                error.className = "form-error-message";
                error.textContent = field.validationMessage;

                errorContainer.appendChild(error);
            });
        });
    }
}